import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppComponent } from './app/app.component';
import Aura from '@primeng/themes/aura'

/*bootstrapApplication(AppComponent, {
  providers: [provideAnimationsAsync()]
}).catch(err => console.error(err));*/


import { provideServiceWorker } from '@angular/service-worker';
import { providePrimeNG } from 'primeng/config';
import { provideRouter, Routes } from '@angular/router';
import { environment } from './environments/environment';
import { ReceiveMoneyAbroadComponent } from './app/receive-money-abroad/receive-money-abroad.component';
import { ReceiveMoneyAbroadConfirmComponent } from './app/receive-money-abroad-confirm/receive-money-abroad-confirm.component';
import { AuthorizePaymentComponent } from './app/authorize-payment/authorize-payment.component';
import { LimitReachedComponent } from './app/limit-reached/limit-reached.component';
import { ServiceUnavailableComponent } from './app/service-unavailable/service-unavailable.component';
import { ReceiveMoneyAbroadAmountComponent } from './app/receive-money-abroad-amount/receive-money-abroad-amount.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { SessionService } from './app/transaction/session.service';
import { authInterceptor } from './app/auth-interceptor';
import { TransferSuccessfulComponent } from './app/transfer-successful/transfer-successful.component';
import { TransferUnsuccessfulComponent } from './app/transfer-unsuccessful/transfer-unsuccessful.component';
import { TransferInProgress } from './app/transafer-in-progress/transafer-in-progress.component';
import { MatchingErrorComponent } from './app/matching-error/matching-error.component';
import { ErrorComponent } from './app/error-page/error.component';
import { AuthGuard } from './app/auth.guard';
import { SessionLoadComponent } from './app/session-load.component';
import { FeatureNotAvailableComponent } from './app/feature-not-available/feature-not-available.component';
import { InsufficientFundsComponent } from './app/unsufficient-funds/insufficient-funds.component';

const routes: Routes = [
  
  { path: '', pathMatch: 'full',resolve: { session: SessionService },component:SessionLoadComponent},
  { path: 'options', component: ReceiveMoneyAbroadComponent , canActivate: [AuthGuard]},
  { path: 'amount', component: ReceiveMoneyAbroadAmountComponent, canActivate: [AuthGuard]},
  { path: 'confirm', component: ReceiveMoneyAbroadConfirmComponent , canActivate: [AuthGuard]},
  { path: 'authorize', component: AuthorizePaymentComponent , canActivate: [AuthGuard]},
  { path: 'transfer-successful', component: TransferSuccessfulComponent, canActivate: [AuthGuard]},
  { path: 'limit', component: LimitReachedComponent , canActivate: [AuthGuard]},
  { path: 'feature-not-available', component: FeatureNotAvailableComponent},
  { path: 'transfer-unsuccessful', component: TransferUnsuccessfulComponent , canActivate: [AuthGuard]},
  { path: 'transfer-processing', component: TransferInProgress , canActivate: [AuthGuard]},
  { path: 'service-unavailable', component: ServiceUnavailableComponent },
  { path: 'unavailable', component: MatchingErrorComponent , canActivate: [AuthGuard]},
  { path: 'error', component: ErrorComponent , canActivate: [AuthGuard]},
  
  { path: 'insufficient-funds', component: InsufficientFundsComponent , canActivate: [AuthGuard]}
    
];


import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './app/core/observability/global-error-handler';
import { observabilityInterceptor } from './app/core/observability/observability.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([observabilityInterceptor, authInterceptor])),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production && !(environment as any).disableServiceWorker,
      registrationStrategy: 'registerWhenStable:3000'
    },
  ),
  providePrimeNG({
    theme:{
      preset: Aura
    }
  })
  ]
});
